// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-414f65b0] {\n  font-size: 1.6rem;\n  padding: 1rem 2.5rem;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
